import User from '@/app/admin/models/User.js'
import Role from '@/app/admin/models/Role.js'

/* eslint-disable camelcase */
export default class UsersManagement {
  constructor ({ max_users, user_list, role_list }) {
    this.maxUsers = max_users || 0
    this._users = user_list.map(rawUser => new User(rawUser))
    this._roles = role_list.map(rawRole => new Role(rawRole))
  }

  get users () {
    return this._users
  }

  get roles () {
    return this._roles
  }

  getUserIndexById (userId) {
    return this._users.findIndex(user => user.userId === userId)
  }

  getUserByIndex (index) {
    return this._users[index]
  }

  getRoleById (roleId) {
    return this._roles.find(role => role.id === roleId)
  }

  removeUser (userId) {
    const userTargetIndex = this.getUserIndexById(userId)
    this._users.splice(userTargetIndex, 1)
  }

  updateUserRole (userId, roleId) {
    const userTargetIndex = this.getUserIndexById(userId)
    const targetUser = this.getUserByIndex(userTargetIndex)
    const { name: roleName } = this.getRoleById(roleId)
    this._users.splice(userTargetIndex, 1, { ...targetUser, roleId: roleId, roleName: roleName })
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/models/UsersManagement.js